import { Card } from "@/components/ui/card";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface ChapterPreview {
	title: string;
	index: number;
	start_page: number;
	end_page: number;
}

/**
 * Conversion hook shown once extraction succeeds: presents the detected
 * chapters as a "your podcast is ready" moment.
 */
export default function ChapterPreviewCard({
	chapters,
}: {
	chapters: ChapterPreview[];
}) {
	const { t } = useTranslation("common");

	return (
		<div className="w-full space-y-3 animate-in fade-in slide-in-from-bottom-4 duration-700">
			<div className="flex items-center justify-center gap-2 text-sm font-semibold text-primary">
				<Sparkles className="h-4 w-4" />
				<span>
					{t("finishSignup.ready.chaptersFound", { count: chapters.length })}
				</span>
			</div>
			<Card className="bg-background/50 border-primary/20 overflow-hidden">
				<div className="divide-y divide-border/50 max-h-[260px] overflow-y-auto">
					{chapters.map((chapter, idx) => (
						<div
							key={`chapter-${chapter.index}-${chapter.title}`}
							className="flex items-center gap-4 p-3 hover:bg-muted/50 transition-colors"
						>
							<span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-bold text-primary">
								{idx + 1}
							</span>
							<div className="min-w-0 flex-1">
								<p className="truncate text-sm font-medium">{chapter.title}</p>
							</div>
						</div>
					))}
				</div>
			</Card>
		</div>
	);
}
